import {ITdoImageGridItem} from './i-tdo-image-grid-item';

export class TdoImageGridContextModel {
  event: MouseEvent;
  contextItem: ITdoImageGridItem;
  selectedItems: ITdoImageGridItem[];
}
